import postgreApiService from "./apiService";
import apiService from "../apiService";
import { CONTENT_ENDPOINTS, RPC_CHAT_ENDPOINTS } from "../endpoints";
import { getStoredCompanyId, getStoredUserId } from "../../utils/user";

const buildJson = (fields) => ({
    json_data: fields,
});

export const getMessageSessions = async () => {
    const UserId = getStoredUserId();
    const CompanyId = getStoredCompanyId();
    const response = await postgreApiService.post(
        RPC_CHAT_ENDPOINTS.GET_MESSAGE_LIST,
        buildJson({ UserId, CompanyId })
    );
    const data = response?.data || {};
    const list = Array.isArray(data) ? data : (data?.data || data?.Data || []);

    if (!Array.isArray(list) || list.length === 0) return [];

    return list.map((item) => {
        const msg = item.LastMessage || "";
        const preview = msg
            ? msg.length > 58 ? `${msg.slice(0, 58)}…` : msg
            : `Conversation #${item.MessageId}`;

        return {
            messageId: item.MessageId,
            label: preview,
            preview,
            time: item.LastMessageOn || item.CreatedOn || "",
            unreadCount: Number(item.UnreadCount || 0),
            lastMessage: msg,
            isLastFromAdmin: item.IsLastFromAdmin || false,
            raw: item,
        };
    });
};

export const markMessageAsRead = async (messageId) => {
    const UserId = getStoredUserId();
    const CompanyId = getStoredCompanyId();
    const response = await postgreApiService.post(
        RPC_CHAT_ENDPOINTS.MARK_AS_READ,
        buildJson({ UserId, CompanyId, MessageId: messageId })
    );
    return response?.data;
};

export const getAttachmentDownloadUrl = async (savedUrl) => {
    if (!savedUrl) throw new Error("Attachment URL is missing.");

    const response = await postgreApiService.post(
        RPC_CHAT_ENDPOINTS.GET_PRESIGNED_DOWNLOAD_URL,
        { p_saved_url: savedUrl }
    );
    const payload = response?.data?.data ?? response?.data;
    const downloadUrl = typeof payload === "string"
        ? payload
        : payload?.url || payload?.downloadUrl || payload?.presignedUrl || payload?.presigned_url;

    if (!downloadUrl) throw new Error("Unable to get the attachment download URL.");
    return downloadUrl;
};

export const getChatMessages = async (messageId) => {
    const CompanyId = getStoredCompanyId();
    const response = await postgreApiService.post(
        RPC_CHAT_ENDPOINTS.GET_MESSAGES,
        buildJson({ MessageId: messageId, CompanyId })
    );
    const data = response?.data || {};
    const messages = Array.isArray(data?.data) ? data.data : [];

    return Promise.all(messages.map(async (message) => {
        const attachments = Array.isArray(message.Attachments) ? message.Attachments : [];
        const resolvedAttachments = await Promise.all(attachments.map(async (attachment) => {
            const savedUrl = attachment.AttachmentUrl || attachment.attachmentUrl || "";
            if (!savedUrl) return attachment;

            try {
                const downloadUrl = await getAttachmentDownloadUrl(savedUrl);
                return { ...attachment, SavedUrl: savedUrl, DownloadUrl: downloadUrl };
            } catch {
                return { ...attachment, SavedUrl: savedUrl, DownloadUrl: "" };
            }
        }));

        return { ...message, Attachments: resolvedAttachments };
    }));
};

export const sendChatMessage = async (messageId, text, attachments = []) => {
    const formData = new FormData();
    formData.append("messageId", messageId);
    formData.append("message", text);
    attachments.forEach((item) => {
        if (item.file) formData.append("attachments", item.file, item.file.name);
    });

    const response = await apiService.post(
        CONTENT_ENDPOINTS.SEND_CHAT_MESSAGE,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response?.data || {};
};
